import { Box, styled, Typography, Button as Btn } from '@mui/material';
import { CheckCircleOutlineRounded } from '@mui/icons-material';

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 56px 22px;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: ${({ theme }) => theme.palette.success.main};
  margin-bottom: 10px;
  margin-top: 16px;
`;

export const Subtitle = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: ${({ theme }) => theme.palette.grey.A700};
  margin-bottom: 30px;
`;

export const Button = styled(Btn)`
  width: 224px;

  & + button {
    margin-top: 10px;
  }
`;

export const Icon = styled(CheckCircleOutlineRounded)`
  width: 67px;
  height: 67px;
`;
